import { Player } from '@/models/orm/Hierarchy';
import routes from './module/routes';
import store from './module/store';

export default {
  name: 'players',
  routes,
  store,
  orm: Player,
};
